module.exports = "//public.zight.com/packs/media/images/main-banner-97cc6fcf025fd9267782c58b205e1ebf.png";